module.exports = __webpack_public_path__ + "static/media/boatyard.b6e72b97.svg";